import { render, staticRenderFns } from "./ChannelFilterLoader.vue?vue&type=template&id=1324c37c&scoped=true"
import script from "./ChannelFilterLoader.vue?vue&type=script&lang=js"
export * from "./ChannelFilterLoader.vue?vue&type=script&lang=js"
import style0 from "./ChannelFilterLoader.vue?vue&type=style&index=0&id=1324c37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324c37c",
  null
  
)

export default component.exports